import { Loader } from '@mews-commander/ui';
import { SentryTeams } from '@mews/enums';
import { SentryErrorBoundary } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { SendReminderToEmailDialog as DialogsHolder } from '../../../../legacy/React/Components/HeadingAction/SendReminderToEmailDialog/SendReminderToEmailDialog';
import { useGetAccountingConfigurationReceivableTrackingEnabled } from '../../../payment/queries';
import { LedgersView } from '../LedgersView';
import { CityLedger } from './CityLedger';
import { CityLedgerFilterProvider } from './context/CityLedgerFilterContext';

export const CityLedgerPage = () => {
    const { data: receivableTrackingEnabled = false } = useGetAccountingConfigurationReceivableTrackingEnabled();
    return receivableTrackingEnabled ? (
        <SentryErrorBoundary team={SentryTeams.Accounting} fallback={<Loader />}>
            <CityLedgerFilterProvider>
                <CityLedger />
                <DialogsHolder />
            </CityLedgerFilterProvider>
        </SentryErrorBoundary>
    ) : (
        <LedgersView activeTab={TextKey.CityLedger} />
    );
};
